import { useEffect, useState } from 'react';

export function useIsMounted() {
  const [state, setState] = useState(false);
  function effect() {
    if (!state) setState(true);
  }
  useEffect(effect, [state]);
  return state;
}
